<template>
    <div class="error-page body-box">
        <div class="hero-header">
            <h3 class="title-with-dot">{{ headerTitle }}</h3>
        </div>

        <div class="error-body">
            <div class="error-body-inner">

                <div class="error-img-box">
                    <div class="error-img-box-inner"></div>
                    <div class="error-img">
                        <img :src="errorImg" alt="">
                    </div>
                </div>
                <h1>{{ title }}</h1>
                <p>{{ content }}</p>
                <div class="btns">
                    <router-link to="/" class="theme-btn">
                        <span class="btn-shape"></span>
                        <span class="btn-shape"></span>
                        <span class="btn-shape"></span>
                        {{ btn1 }}
                    </router-link>
                    <router-link to="/projects" class="theme-btn theme-btn-white">
                        {{ btn2 }}
                        <i class="las la-arrow-right arrow-right"></i>
                    </router-link>
                </div>

            </div>

            <ohilo-footer />
        </div>
    </div>
</template>

<script>
import OhiloFooter from '@/components/common/OhiloFooter.vue';

export default {
    name: 'ErrorView',
    components: {
        OhiloFooter
    },
    data() {
        return {
            headerTitle: 'Oops! 404',
            errorImg: require('@/assets/images/me2.png'),
            title: 'Page not found.',
            content: 'The page is does not exist.',
            btn1: 'Back to Home',
            btn2: 'See My Work'
        }
    }
}
</script>